import {TXY} from "@ui/api/features"

type TLoadFeatures = (xy: TXY) => Promise<void>

export type TFeatureConstructorParams = {
  seconds: number
  minZoom?: number | null   // минимальный зум, на котором грузятся и показываются точки интереса, по умолчанию 20
  maxZoom?: number | null    // максимальный зум, на котором грузятся и показываются точки интереса, по умолчанию 0
}

export interface IFeature {
  readonly zoom: {min: number, max: number}
  check(minX: number, maxX: number, minY: number, maxY: number): Promise<void>
  load: TLoadFeatures
  toggle: (isVisible: boolean, currentZoom?: number) => void
}

export abstract class Feature implements IFeature {
  private seconds: number
  private matrix: boolean[][] = []
  zoom: {min: number, max: number}

  abstract load(xy: TXY): Promise<void>
  abstract toggle(isVisible: boolean, currentZoom?: number): void

  constructor({seconds, minZoom, maxZoom}: TFeatureConstructorParams) {
    this.seconds = seconds
    this.zoom = {min: minZoom || 20, max: maxZoom || 0}
  }

  async check(minX: number, maxX: number, minY: number, maxY: number): Promise<void> {
    // [номер минимальной ячейки, номер максимальной ячейки + 1] в которые попадают min и max
    const borderX = [Math.floor((minX + 180) * 3600 / this.seconds), Math.ceil((maxX + 180) * 3600 / this.seconds)]
    const borderY = [Math.floor((minY + 90) * 3600 / this.seconds), Math.ceil((maxY + 90) * 3600 / this.seconds)]

    for (let x = borderX[0]; x < borderX[1]; x++) {
      for (let y = borderY[0]; y < borderY[1]; y++) {
        if (!this.matrix[x]) {
          this.matrix[x] = []
        }
        if (!this.matrix[x][y]) {
          this.matrix[x][y] = true
          await this
            .load({x, y})
            .catch(e => {
              this.matrix[x][y] = false
              console.log(`Error while getting features, error -${e}.`, e)
            })
        }
      }
    }
  }
}
